import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { APIURL } from '../shared/consts/url.const';
import { StudentsResponse, PillsResponse } from '../models/api/students.model';

@Injectable({
	providedIn: 'root'
})
export class StudentsService {
	apiUrl = APIURL;

	httpClient = inject(HttpClient);

	getStudents() {
		return this.httpClient.get<StudentsResponse>(`${this.apiUrl}/students`);
	}

	updateStudents(body: StudentsResponse) {
		return this.httpClient.post(`${this.apiUrl}/students`, body);
	}

	getPills(language: string) {
		const headers = new HttpHeaders({
			'Accept-Language': language
		});

		return this.httpClient.get<PillsResponse[]>(`${this.apiUrl}/students/pills`, { headers });
	}

	cancelProcess(guid: string) {
		return this.httpClient.post(`${this.apiUrl}/students/process/${guid}/cancel`, null);
	}
}
